import * as React from 'react';
export const VNSvg = React.forwardRef(function VNSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#E25950',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M8.08 7.785 6.357 8.821a.3.3 0 0 1-.447-.327l.457-1.905-1.545-1.443a.3.3 0 0 1 .192-.52l1.898-.083.895-1.95a.3.3 0 0 1 .546 0l.895 1.95 1.898.084a.3.3 0 0 1 .192.519L9.793 6.589l.457 1.905a.3.3 0 0 1-.447.327L8.08 7.785Z',
      }),
    ),
  );
});
VNSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var VN = {
  category: 'flag',
  colorable: false,
  name: 'VN',
  svg: VNSvg,
};
